module.exports = __webpack_public_path__ + "pc/img/work_detail6.92b89df8.jpg";